const API_URL = process.env.REACT_APP_API_URL;

// Helper function to handle the response from fetch calls
async function handleResponse(response) {
    if (!response.ok) {
        const errorData = await response.json();
        return { error: true, message: errorData.message || 'Network error' };
    }
    return { error: false, data: await response.json() };
}

// Generic fetch function
async function fetchData(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return await handleResponse(response);
    } catch (error) {
        console.error('Fetch error:', error);
        return { error: true, message: error.message };
    }
}

// Fetch a single plant by ID
export async function fetchPlant(plantId) {
    if (!plantId) {
        console.error('No plantId provided');
        return { error: true, message: 'plantId is required' };
    }
    return fetchData(`${API_URL}/plants/${encodeURIComponent(plantId)}`);
}

// Get the plant of the day
export async function getPlantOfTheDay() {
    try {
        const response = await fetch(`${API_URL}/plants/OfTheDay`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
}

// Fetch plants by name
export async function fetchPlantsByName(name) {
    if (!name) {
        console.error('No name provided');
        return { error: true, message: 'name is required' };
    }
    return fetchData(`${API_URL}/plants/byName/${encodeURIComponent(name)}`);
}

export async function identifyPlantByImage(file) {
    if (!file) {
        console.error('No file provided');
        return { error: true, message: 'file is required' };
    }
    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch(`${API_URL}/plants/identify`, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            const errorData = await response.json();
            return { error: true, message: errorData.message || 'Network error' };
        }
        return { error: false, data: await response.json() };
    } catch (error) {
        return { error: true, message: error.message };
    }
}